<script lang="ts" context="module">
	declare const jQuery: any;
</script>

<script lang="ts">
	import { onMount } from 'svelte';
	import { bootsnav } from '$lib/bootsnav';
	import { SITE_DISPLAY_NAME } from '$lib/constants';

	let navRoot;

	onMount(async () => {
		// Initialize
		jQuery(document).ready(function () {
			bootsnav.initialize();
		});

		// Reset on resize
		jQuery(window).on('resize', function () {
			bootsnav.hoverDropdown();
			setTimeout(function () {
				bootsnav.navbarSticky();
			}, 500);

			// Toggle Bars
			jQuery('.navbar-toggle').each(function () {
				jQuery('.eicon', this).removeClass('ion-android-close');
				jQuery('.eicon', this).addClass('ion-android-menu');
				jQuery(this).removeClass('fixed');
			});
			jQuery('.navbar-collapse').removeClass('in');
			jQuery('.navbar-collapse').removeClass('on');
			jQuery('.navbar-collapse').removeClass('bounceIn');
		});

		// Setup close on click since this is a single page app
		let getIn = jQuery('nav.navbar.bootsnav').find('ul.nav').data('in');
		jQuery('nav.navbar.bootsnav').on('click', function () {
			jQuery('li.dropdown', this).removeClass('on');
			jQuery('.dropdown-menu', this).stop().fadeOut();
			jQuery('.dropdown-menu', this).removeClass(getIn);
			jQuery('.col-menu', this).removeClass('on');
			jQuery('.col-menu .content', this).stop().fadeOut();
			jQuery('.col-menu .content', this).removeClass(getIn);

			jQuery('.navbar-toggle').each(function () {
				jQuery('.eicon', this).removeClass('ion-android-close');
				jQuery('.eicon', this).addClass('ion-android-menu');
				jQuery('.navbar-collapse').removeClass('in');
				jQuery('.navbar-collapse').removeClass('on');
			});
		});
	});
</script>

<nav
	bind:this={navRoot}
	class="navbar navbar-default navbar-fixed navbar-transparent dark bootsnav white on no-full brand-center"
>
	<div class="container">
		<!--=== Start Header Navigation ===-->
		<div class="navbar-header">
			<button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-menu">
				<i class="eicon ion-android-menu" />
			</button>
			<div class="logo">
				<a href="/" class="navbar-brand">
					<img
						class="logo logo-display logo-scrolled"
						src="/assets/images/logo-light.webp"
						alt="{SITE_DISPLAY_NAME} Logo"
					/>
				</a>
			</div>
		</div>
		<!--=== End Header Navigation ===-->

		<!--=== Collect the nav links, forms, and other content for toggling ===-->
		<div class="collapse navbar-collapse" id="navbar-menu">
			<ul class="nav navbar-nav navbar-center" data-in="fadeIn" data-out="fadeOut">
				<li class="dropdown megamenu-fw">
					<a href="/">Home</a>
				</li>
				<li class="dropdown">
					<!-- svelte-ignore a11y-invalid-attribute -->
					<a href="/about" class="dropdown-toggle" data-toggle="dropdown">About</a>
					<ul class="dropdown-menu">
						<li><a href="/about">Our Story</a></li>
						<li><a href="/about/genesis-standard">The Genesis Standard</a></li>
						<li><a href="/about/our-goal">Our Goal</a></li>
						<li><a href="/about/why-choose-genesis">Why Choose Us</a></li>
						<li><a href="/about/awards">Awards</a></li>
						<li><a href="/about/faq">FAQ</a></li>
					</ul>
				</li>
				<li class="dropdown">
					<!-- svelte-ignore a11y-invalid-attribute -->
					<a href="/services" class="dropdown-toggle" data-toggle="dropdown">Services</a>
					<ul class="dropdown-menu">
						<li><a href="/services/lawncare">Lawn Care</a></li>
						<li><a href="/services/maintenance">Seasonal Maintenance</a></li>
						<li><a href="/services/hardscape">Hardscape</a></li>
						<li><a href="/services/drainage-grading">Drainage & Grading</a></li>
						<li><a href="/services/design">Design</a></li>
					</ul>
				</li>
				<li class="dropdown">
					<!-- svelte-ignore a11y-invalid-attribute -->
					<a href="/portfolio">Portfolio</a>
				</li>
				<li class="dropdown megamenu-fw">
					<a href="/testimonials">Testimonials</a>
				</li>
				<li class="dropdown megamenu-fw">
					<!-- svelte-ignore a11y-invalid-attribute -->
					<a href="/contact">Contact</a>
					<ul class="dropdown-menu">
						<li><a href="/contact#schedule-estimate">Schedule Estimate</a></li>
					</ul>
				</li>
			</ul>
		</div>
		<!--=== /.navbar-collapse ===-->
	</div>
</nav>

<style lang="scss">
	.navbar-brand {
		padding: 0px;
	}

	.logo {
		img {
			max-height: 67px;
		}

		.logo-scrolled img {
			// max-height: 200px;
		}
	}

	.navbar {
		> .container .navbar-brand,
		> .container-fluid .navbar-brand {
			margin-left: 0px;
		}
	}

	nav {
		&.navbar.bootsnav {
			li.dropdown ul.dropdown-menu {
				background: #212121;

				li a:hover {
					color: #fff;
				}
			}
			&.navbar-transparent {
				&.dark ul.nav > li > a {
					color: #fff;
					background-color: #212121;
				}

				&.brand-center {
					.navbar-brand {
						padding: 0px;
						margin: 0px;

						.logo {
							max-height: 67px;
						}

						.logo-display {
							// max-height: 200px;
						}

						.logo-scrolled {
							// max-height: 200px;
						}
					}
				}
			}
		}
	}

	nav.navbar.bootsnav.navbar-transparent.brand-center .logo {
		margin-top: 4px;
	}

	// .brand-center .logo {
	// 	margin-top: -1px;
	// }

	@media (max-width: 992px) {
		nav {
			&.navbar.bootsnav {
				li.dropdown ul.dropdown-menu {
					li a {
						color: #fff;
					}
				}
			}

			.navbar-collapse {
				background-color: #212121;
			}
		}
	}

	@media (min-width: 768px) and (max-width: 992px) {
		.container > .navbar-collapse,
		.container-fluid > .navbar-collapse {
			top: 60px;
		}
	}

	@media (max-width: 991px) {
		nav.navbar.bootsnav.navbar-fixed {
			height: 60px;
		}
	}

	@media (min-width: 768px) {
		.container > .navbar-header,
		.container-fluid > .navbar-header,
		.container > .navbar-collapse,
		.container-fluid > .navbar-collapse {
			display: block;
			width: 100%;
			position: absolute;
			text-align: center;
			left: 0;
		}
	}
</style>
